import { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDisableScrolling from '../../Hooks/useDisableScrolling';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export function Modal({ children, expand = false, timeout = false, disableScrolling = true }) {
  const [isFinished, setIsFinished] = useState(!timeout);

  useEffect(() => {
    if (timeout) setIsFinished(false);
    const t = setTimeout(() => setIsFinished(true), 800);
    return () => clearTimeout(t);
  }, [expand, timeout]);

  // Use the cleaned hook here
  useDisableScrolling(disableScrolling && (expand || !isFinished));

  return (
    <Overlay className={`transition-opacity duration-500 ease-in-out ${(expand || !isFinished) ? 'opacity-100 pointer-events-auto ' : 'opacity-0 pointer-events-none '} `}>
      <div className="min-h-full w-full flex items-center justify-center md:p-10">
        {children}
      </div>
    </Overlay>
  );
}